<div class='lg:container lg:mx-auto pb-6 px-6'>
  <h1 class='text-4xl p-4'>New Building</h1>
  <app-form-building-details [isNew]="true" [details$]="details$" [success$]='success$'></app-form-building-details>
</div>
